import React from "react";
// reactstrap components
import { Container, Row } from "reactstrap";
import Background from "../../assets/img/noah-rosenfield.jpg";

function Error404() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("error-404");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("error-404");
    };
  });
  return (
    <>
      <div
        className="background-img"
        style={{
          backgroundImage: "url(" + Background + ")",
        }}
      >
        <div className="filter" />
        <Container>
          <Row>
            <h1 className="title">
              404
              <br />
              <p className="error-msg">
                The page you requested could not be found
              </p>
            </h1>
          </Row>
          <div className="container-cards"></div>
        </Container>
      </div>
    </>
  );
}

export default Error404;
